// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetOhlcPair (params?: {}): Promise<Dict>;
    publicGetOrderBookPair (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<List>;
    publicGetTickerHourPair (params?: {}): Promise<Dict>;
    publicGetTickerPair (params?: {}): Promise<Dict>;
    publicGetTransactionsPair (params?: {}): Promise<List>;
    publicGetTradingPairsInfo (params?: {}): Promise<List>;
    publicGetMarkets (params?: {}): Promise<List>;
    publicGetCurrencies (params?: {}): Promise<List>;
    publicGetEurUsd (params?: {}): Promise<Dict>;
    publicGetTravelRuleVasps (params?: {}): Promise<Dict>;
    publicGetFundingRateMarketSymbol (params?: {}): Promise<Dict>;
    publicGetFundingRateHistoryPair (params?: {}): Promise<Dict>;
    publicGetDerivativesMarketHours (params?: {}): Promise<List>;
    publicGetDerivativesMarketHoursMarketSymbol (params?: {}): Promise<Dict>;
    privateGetTravelRuleContacts (params?: {}): Promise<List>;
    privateGetContactsContactUuid (params?: {}): Promise<Dict>;
    privateGetTravelRuleUtxoXpubRegistrations (params?: {}): Promise<List>;
    privateGetTravelRuleUtxoXpubRegistrationsRegistrationId (params?: {}): Promise<Dict>;
    privateGetTravelRuleAddressVerification (params?: {}): Promise<Dict>;
    privateGetCryptoTransactionsDeposits (params?: {}): Promise<List>;
    privateGetEarnSubscriptions (params?: {}): Promise<List>;
    privateGetEarnTransactions (params?: {}): Promise<List>;
    privateGetTradeHistory (params?: {}): Promise<List>;
    privateGetTradeHistoryPair (params?: {}): Promise<List>;
    privatePostAccountBalances (params?: {}): Promise<Dict>;
    privatePostAccountBalancesCurrency (params?: {}): Promise<Dict>;
    privatePostBalance (params?: {}): Promise<Dict>;
    privatePostBalancePair (params?: {}): Promise<Dict>;
    privatePostBchWithdrawal (params?: {}): Promise<Dict>;
    privatePostBchAddress (params?: {}): Promise<Dict>;
    privatePostUserTransactions (params?: {}): Promise<List>;
    privatePostUserTransactionsPair (params?: {}): Promise<List>;
    privatePostCryptoTransactions (params?: {}): Promise<Dict>;
    privatePostCryptoTransactionsDepositsDepositIdReject (params?: {}): Promise<Dict>;
    privatePostOpenOrder (params?: {}): Promise<Dict>;
    privatePostOpenOrdersAll (params?: {}): Promise<List>;
    privatePostOpenOrdersPair (params?: {}): Promise<List>;
    privatePostReplaceOrder (params?: {}): Promise<Dict>;
    privatePostOrderStatus (params?: {}): Promise<Dict>;
    privatePostCancelOrder (params?: {}): Promise<Dict>;
    privatePostCancelAllOrders (params?: {}): Promise<Dict>;
    privatePostCancelAllOrdersPair (params?: {}): Promise<Dict>;
    privatePostBuyPair (params?: {}): Promise<Dict>;
    privatePostBuyMarketPair (params?: {}): Promise<Dict>;
    privatePostBuyInstantPair (params?: {}): Promise<Dict>;
    privatePostSellPair (params?: {}): Promise<Dict>;
    privatePostSellMarketPair (params?: {}): Promise<Dict>;
    privatePostSellInstantPair (params?: {}): Promise<Dict>;
    privatePostTransferToMain (params?: {}): Promise<Dict>;
    privatePostTransferFromMain (params?: {}): Promise<Dict>;
    privatePostMyTradingPairs (params?: {}): Promise<List>;
    privatePostFeesTrading (params?: {}): Promise<List>;
    privatePostFeesTradingMarketSymbol (params?: {}): Promise<Dict>;
    privatePostFeesWithdrawal (params?: {}): Promise<List>;
    privatePostFeesWithdrawalCurrency (params?: {}): Promise<Dict>;
    privatePostWithdrawalRequests (params?: {}): Promise<List>;
    privatePostWithdrawalOpen (params?: {}): Promise<Dict>;
    privatePostWithdrawalStatus (params?: {}): Promise<Dict>;
    privatePostWithdrawalCancel (params?: {}): Promise<Dict>;
    privatePostLiquidationAddressNew (params?: {}): Promise<Dict>;
    privatePostLiquidationAddressInfo (params?: {}): Promise<Dict>;
    privatePostBtcUnconfirmed (params?: {}): Promise<Dict>;
    privatePostWebsocketsToken (params?: {}): Promise<Dict>;
    privatePostRevokeAllApiKeys (params?: {}): Promise<Dict>;
    privatePostGetMaxOrderAmount (params?: {}): Promise<Dict>;
    privatePostOrderData (params?: {}): Promise<List>;
    privatePostAccountOrderData (params?: {}): Promise<List>;
    privatePostBtcWithdrawal (params?: {}): Promise<Dict>;
    privatePostBtcAddress (params?: {}): Promise<Dict>;
    privatePostRippleWithdrawal (params?: {}): Promise<Dict>;
    privatePostRippleAddress (params?: {}): Promise<Dict>;
    privatePostLtcWithdrawal (params?: {}): Promise<Dict>;
    privatePostLtcAddress (params?: {}): Promise<Dict>;
    privatePostEthWithdrawal (params?: {}): Promise<Dict>;
    privatePostEthAddress (params?: {}): Promise<Dict>;
    privatePostXrpWithdrawal (params?: {}): Promise<Dict>;
    privatePostXrpAddress (params?: {}): Promise<Dict>;
    privatePostXlmWithdrawal (params?: {}): Promise<Dict>;
    privatePostXlmAddress (params?: {}): Promise<Dict>;
    privatePostPaxWithdrawal (params?: {}): Promise<Dict>;
    privatePostPaxAddress (params?: {}): Promise<Dict>;
    privatePostLinkWithdrawal (params?: {}): Promise<Dict>;
    privatePostLinkAddress (params?: {}): Promise<Dict>;
    privatePostUsdcWithdrawal (params?: {}): Promise<Dict>;
    privatePostUsdcAddress (params?: {}): Promise<Dict>;
    privatePostOmgWithdrawal (params?: {}): Promise<Dict>;
    privatePostOmgAddress (params?: {}): Promise<Dict>;
    privatePostDaiWithdrawal (params?: {}): Promise<Dict>;
    privatePostDaiAddress (params?: {}): Promise<Dict>;
    privatePostKncWithdrawal (params?: {}): Promise<Dict>;
    privatePostKncAddress (params?: {}): Promise<Dict>;
    privatePostMkrWithdrawal (params?: {}): Promise<Dict>;
    privatePostMkrAddress (params?: {}): Promise<Dict>;
    privatePostZrxWithdrawal (params?: {}): Promise<Dict>;
    privatePostZrxAddress (params?: {}): Promise<Dict>;
    privatePostGusdWithdrawal (params?: {}): Promise<Dict>;
    privatePostGusdAddress (params?: {}): Promise<Dict>;
    privatePostAaveWithdrawal (params?: {}): Promise<Dict>;
    privatePostAaveAddress (params?: {}): Promise<Dict>;
    privatePostBatWithdrawal (params?: {}): Promise<Dict>;
    privatePostBatAddress (params?: {}): Promise<Dict>;
    privatePostUmaWithdrawal (params?: {}): Promise<Dict>;
    privatePostUmaAddress (params?: {}): Promise<Dict>;
    privatePostSnxWithdrawal (params?: {}): Promise<Dict>;
    privatePostSnxAddress (params?: {}): Promise<Dict>;
    privatePostUniWithdrawal (params?: {}): Promise<Dict>;
    privatePostUniAddress (params?: {}): Promise<Dict>;
    privatePostYfiWithdrawal (params?: {}): Promise<Dict>;
    privatePostYfiAddress (params?: {}): Promise<Dict>;
    privatePostAudioWithdrawal (params?: {}): Promise<Dict>;
    privatePostAudioAddress (params?: {}): Promise<Dict>;
    privatePostCrvWithdrawal (params?: {}): Promise<Dict>;
    privatePostCrvAddress (params?: {}): Promise<Dict>;
    privatePostAlgoWithdrawal (params?: {}): Promise<Dict>;
    privatePostAlgoAddress (params?: {}): Promise<Dict>;
    privatePostCompWithdrawal (params?: {}): Promise<Dict>;
    privatePostCompAddress (params?: {}): Promise<Dict>;
    privatePostGrtWithdrawal (params?: {}): Promise<Dict>;
    privatePostGrtAddress (params?: {}): Promise<Dict>;
    privatePostUsdtWithdrawal (params?: {}): Promise<Dict>;
    privatePostUsdtAddress (params?: {}): Promise<Dict>;
    privatePostEurtWithdrawal (params?: {}): Promise<Dict>;
    privatePostEurtAddress (params?: {}): Promise<Dict>;
    privatePostMaticWithdrawal (params?: {}): Promise<Dict>;
    privatePostMaticAddress (params?: {}): Promise<Dict>;
    privatePostSushiWithdrawal (params?: {}): Promise<Dict>;
    privatePostSushiAddress (params?: {}): Promise<Dict>;
    privatePostChzWithdrawal (params?: {}): Promise<Dict>;
    privatePostChzAddress (params?: {}): Promise<Dict>;
    privatePostEnjWithdrawal (params?: {}): Promise<Dict>;
    privatePostEnjAddress (params?: {}): Promise<Dict>;
    privatePostAlphaWithdrawal (params?: {}): Promise<Dict>;
    privatePostAlphaAddress (params?: {}): Promise<Dict>;
    privatePostFttWithdrawal (params?: {}): Promise<Dict>;
    privatePostFttAddress (params?: {}): Promise<Dict>;
    privatePostStorjWithdrawal (params?: {}): Promise<Dict>;
    privatePostStorjAddress (params?: {}): Promise<Dict>;
    privatePostAxsWithdrawal (params?: {}): Promise<Dict>;
    privatePostAxsAddress (params?: {}): Promise<Dict>;
    privatePostSandWithdrawal (params?: {}): Promise<Dict>;
    privatePostSandAddress (params?: {}): Promise<Dict>;
    privatePostHbarWithdrawal (params?: {}): Promise<Dict>;
    privatePostHbarAddress (params?: {}): Promise<Dict>;
    privatePostRgtWithdrawal (params?: {}): Promise<Dict>;
    privatePostRgtAddress (params?: {}): Promise<Dict>;
    privatePostFetWithdrawal (params?: {}): Promise<Dict>;
    privatePostFetAddress (params?: {}): Promise<Dict>;
    privatePostSklWithdrawal (params?: {}): Promise<Dict>;
    privatePostSklAddress (params?: {}): Promise<Dict>;
    privatePostCelWithdrawal (params?: {}): Promise<Dict>;
    privatePostCelAddress (params?: {}): Promise<Dict>;
    privatePostSxpWithdrawal (params?: {}): Promise<Dict>;
    privatePostSxpAddress (params?: {}): Promise<Dict>;
    privatePostAdaWithdrawal (params?: {}): Promise<Dict>;
    privatePostAdaAddress (params?: {}): Promise<Dict>;
    privatePostSlpWithdrawal (params?: {}): Promise<Dict>;
    privatePostSlpAddress (params?: {}): Promise<Dict>;
    privatePostFtmWithdrawal (params?: {}): Promise<Dict>;
    privatePostFtmAddress (params?: {}): Promise<Dict>;
    privatePostPerpWithdrawal (params?: {}): Promise<Dict>;
    privatePostPerpAddress (params?: {}): Promise<Dict>;
    privatePostDydxWithdrawal (params?: {}): Promise<Dict>;
    privatePostDydxAddress (params?: {}): Promise<Dict>;
    privatePostGalaWithdrawal (params?: {}): Promise<Dict>;
    privatePostGalaAddress (params?: {}): Promise<Dict>;
    privatePostShibWithdrawal (params?: {}): Promise<Dict>;
    privatePostShibAddress (params?: {}): Promise<Dict>;
    privatePostAmpWithdrawal (params?: {}): Promise<Dict>;
    privatePostAmpAddress (params?: {}): Promise<Dict>;
    privatePostSgbWithdrawal (params?: {}): Promise<Dict>;
    privatePostSgbAddress (params?: {}): Promise<Dict>;
    privatePostAvaxWithdrawal (params?: {}): Promise<Dict>;
    privatePostAvaxAddress (params?: {}): Promise<Dict>;
    privatePostWbtcWithdrawal (params?: {}): Promise<Dict>;
    privatePostWbtcAddress (params?: {}): Promise<Dict>;
    privatePostCtsiWithdrawal (params?: {}): Promise<Dict>;
    privatePostCtsiAddress (params?: {}): Promise<Dict>;
    privatePostCvxWithdrawal (params?: {}): Promise<Dict>;
    privatePostCvxAddress (params?: {}): Promise<Dict>;
    privatePostImxWithdrawal (params?: {}): Promise<Dict>;
    privatePostImxAddress (params?: {}): Promise<Dict>;
    privatePostNexoWithdrawal (params?: {}): Promise<Dict>;
    privatePostNexoAddress (params?: {}): Promise<Dict>;
    privatePostUstWithdrawal (params?: {}): Promise<Dict>;
    privatePostUstAddress (params?: {}): Promise<Dict>;
    privatePostAntWithdrawal (params?: {}): Promise<Dict>;
    privatePostAntAddress (params?: {}): Promise<Dict>;
    privatePostGodsWithdrawal (params?: {}): Promise<Dict>;
    privatePostGodsAddress (params?: {}): Promise<Dict>;
    privatePostRadWithdrawal (params?: {}): Promise<Dict>;
    privatePostRadAddress (params?: {}): Promise<Dict>;
    privatePostBandWithdrawal (params?: {}): Promise<Dict>;
    privatePostBandAddress (params?: {}): Promise<Dict>;
    privatePostInjWithdrawal (params?: {}): Promise<Dict>;
    privatePostInjAddress (params?: {}): Promise<Dict>;
    privatePostRlyWithdrawal (params?: {}): Promise<Dict>;
    privatePostRlyAddress (params?: {}): Promise<Dict>;
    privatePostRndrWithdrawal (params?: {}): Promise<Dict>;
    privatePostRndrAddress (params?: {}): Promise<Dict>;
    privatePostVegaWithdrawal (params?: {}): Promise<Dict>;
    privatePostVegaAddress (params?: {}): Promise<Dict>;
    privatePost1inchWithdrawal (params?: {}): Promise<Dict>;
    privatePost1inchAddress (params?: {}): Promise<Dict>;
    privatePostEnsWithdrawal (params?: {}): Promise<Dict>;
    privatePostEnsAddress (params?: {}): Promise<Dict>;
    privatePostManaWithdrawal (params?: {}): Promise<Dict>;
    privatePostManaAddress (params?: {}): Promise<Dict>;
    privatePostLrcWithdrawal (params?: {}): Promise<Dict>;
    privatePostLrcAddress (params?: {}): Promise<Dict>;
    privatePostApeWithdrawal (params?: {}): Promise<Dict>;
    privatePostApeAddress (params?: {}): Promise<Dict>;
    privatePostMplWithdrawal (params?: {}): Promise<Dict>;
    privatePostMplAddress (params?: {}): Promise<Dict>;
    privatePostEurocWithdrawal (params?: {}): Promise<Dict>;
    privatePostEurocAddress (params?: {}): Promise<Dict>;
    privatePostSolWithdrawal (params?: {}): Promise<Dict>;
    privatePostSolAddress (params?: {}): Promise<Dict>;
    privatePostDotWithdrawal (params?: {}): Promise<Dict>;
    privatePostDotAddress (params?: {}): Promise<Dict>;
    privatePostNearWithdrawal (params?: {}): Promise<Dict>;
    privatePostNearAddress (params?: {}): Promise<Dict>;
    privatePostDogeWithdrawal (params?: {}): Promise<Dict>;
    privatePostDogeAddress (params?: {}): Promise<Dict>;
    privatePostFlrWithdrawal (params?: {}): Promise<Dict>;
    privatePostFlrAddress (params?: {}): Promise<Dict>;
    privatePostDgldWithdrawal (params?: {}): Promise<Dict>;
    privatePostDgldAddress (params?: {}): Promise<Dict>;
    privatePostLdoWithdrawal (params?: {}): Promise<Dict>;
    privatePostLdoAddress (params?: {}): Promise<Dict>;
    privatePostTravelRuleContacts (params?: {}): Promise<Dict>;
    privatePostTravelRuleUtxoXpubRegistrations (params?: {}): Promise<Dict>;
    privatePostTravelRuleUtxoXpubRegistrationsRegistrationIdRevoke (params?: {}): Promise<Dict>;
    privatePostEarnSubscribe (params?: {}): Promise<Dict>;
    privatePostEarnSubscriptionsSetting (params?: {}): Promise<Dict>;
    privatePostEarnUnsubscribe (params?: {}): Promise<Dict>;
    privatePostWecanWithdrawal (params?: {}): Promise<Dict>;
    privatePostWecanAddress (params?: {}): Promise<Dict>;
    privatePostTracWithdrawal (params?: {}): Promise<Dict>;
    privatePostTracAddress (params?: {}): Promise<Dict>;
    privatePostEurcvWithdrawal (params?: {}): Promise<Dict>;
    privatePostEurcvAddress (params?: {}): Promise<Dict>;
    privatePostPyusdWithdrawal (params?: {}): Promise<Dict>;
    privatePostPyusdAddress (params?: {}): Promise<Dict>;
    privatePostLmwrWithdrawal (params?: {}): Promise<Dict>;
    privatePostLmwrAddress (params?: {}): Promise<Dict>;
    privatePostPepeWithdrawal (params?: {}): Promise<Dict>;
    privatePostPepeAddress (params?: {}): Promise<Dict>;
    privatePostBlurWithdrawal (params?: {}): Promise<Dict>;
    privatePostBlurAddress (params?: {}): Promise<Dict>;
    privatePostVextWithdrawal (params?: {}): Promise<Dict>;
    privatePostVextAddress (params?: {}): Promise<Dict>;
    privatePostCsprWithdrawal (params?: {}): Promise<Dict>;
    privatePostCsprAddress (params?: {}): Promise<Dict>;
    privatePostVchfWithdrawal (params?: {}): Promise<Dict>;
    privatePostVchfAddress (params?: {}): Promise<Dict>;
    privatePostVeurWithdrawal (params?: {}): Promise<Dict>;
    privatePostVeurAddress (params?: {}): Promise<Dict>;
    privatePostTrufWithdrawal (params?: {}): Promise<Dict>;
    privatePostTrufAddress (params?: {}): Promise<Dict>;
    privatePostWifWithdrawal (params?: {}): Promise<Dict>;
    privatePostWifAddress (params?: {}): Promise<Dict>;
    privatePostSmtWithdrawal (params?: {}): Promise<Dict>;
    privatePostSmtAddress (params?: {}): Promise<Dict>;
    privatePostSuiWithdrawal (params?: {}): Promise<Dict>;
    privatePostSuiAddress (params?: {}): Promise<Dict>;
    privatePostJupWithdrawal (params?: {}): Promise<Dict>;
    privatePostJupAddress (params?: {}): Promise<Dict>;
    privatePostOndoWithdrawal (params?: {}): Promise<Dict>;
    privatePostOndoAddress (params?: {}): Promise<Dict>;
    privatePostBobaWithdrawal (params?: {}): Promise<Dict>;
    privatePostBobaAddress (params?: {}): Promise<Dict>;
    privatePostPythWithdrawal (params?: {}): Promise<Dict>;
    privatePostPythAddress (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
